module.exports = __webpack_public_path__ + "img/Step1.1299c7f2.png";